import { Component, OnInit } from '@angular/core';
import { Practice } from 'src/app/models/practice';
import { PracticeService } from 'src/app/services/practice.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-owner',
  templateUrl: './owner.component.html',
  styleUrls: ['./owner.component.scss']
})
export class OwnerComponent implements OnInit {
  public practice: Practice;
  public practiceId;
  public loadedPractice:boolean=false;

  constructor(
    private _practice: PracticeService,
    private _route: ActivatedRoute
  ) {
    this.practiceId = this._route.snapshot.paramMap.get("practiceId");
  }

  public getPractice(){
    this._practice.getPractice(this.practiceId).subscribe(
      res=>{
        this.practice=new Practice(res);
        this.loadedPractice=true;
      }
    );
  }

  ngOnInit() {
    this.getPractice();
  }

}
